import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { PhoneRecord, ThreadItem, ThreadAIActivity } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v2/models.pb';

/**
 * KnownThreadStatus is a FE-only enum. The BE just uses a string, but we want to keep status consistent.
 */
export enum KnownThreadStatus {
  NEW = 'new',
  READ = 'read',
  ERROR = 'error',
}

/**
 * OptimisticUpdateStatusDetails is a FE-only enum used to track the status of an optimistic update.
 */
export enum OptimisticUpdateStatusDetails {
  DELETING = 'DELETING',
  SENDING = 'SENDING',
}

export type MessagingUIType = 'mini-chat' | 'inbox' | 'integrated-messaging';

export type CountThreadsStatusUpdate = 'actionable' | 'not-actionable' | 'read' | 'unread' | 'error';

export type SMSItem = Extract<ThreadItem, { smsMessage: SMS }>;
export type CallRecordItem = Extract<ThreadItem, { callRecord: PhoneRecord }>;
export type AiActivityItem = Extract<ThreadItem, { aiActivity: ThreadAIActivity }>;
